import { Box, Grid } from "@material-ui/core";
import { useContext } from "react";
import PersonalDataComponent from "../../../components/materialui/Shared/PersonalDataComponent";
import AddressDataComponent from "../../../components/materialui/Shared/AddressDataComponent";
import { MedicoAssistenteContext } from "../../../../context/MedicoAssistenteContext";
import FormBase from "../../../../forms/FormBase";
import Steps from "../../../../components/steps/Steps";
import Controls from "../../../../components/controls/Controls";
import { TipoCadastroMedicoAssistenteOptions } from "../../../../data/TipoCadastroMedicoAssistente";
import { RegiaoOptions } from "../../../../data/Regiao";

export default function PersonalAddressDataStep() {
  const { state, dispatch } = useContext(MedicoAssistenteContext);

  const onInputPersonalChange = (name: string, form: FormBase, value: any) => {
    dispatch({
      type: "UPDATE_FORM",
      payload: { form, value, name },
    });
  };

  const onInputAddressChange = (name: string, form: FormBase, value: any) => {
    dispatch({
      type: "UPDATE_FORM",
      payload: { form, value, name },
    });
  };

  const onRadioGroupChange = (name: string, form: FormBase, value: any) => {
    dispatch({
      type: "UPDATE_FORM",
      payload: { form, value, name },
    });
  };

  return (
    <div>
      <Steps.StepTitle text="Dados Pessoais" />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Controls.RadioGroup
            name="Region"
            label="Região"
            value={state.PersonalAddressDataForm.Region.Value}
            onChange={(e) => {
              onRadioGroupChange(
                "Region",
                state.PersonalAddressDataForm,
                e.target.value
              );
            }}
            items={RegiaoOptions}
            error={state.PersonalAddressDataForm.Region.Error}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controls.RadioGroup
            name="TypeRegistration"
            label="Tipo Cadastro"
            value={state.PersonalAddressDataForm.TypeRegistration.Value}
            onChange={(e) => {
              onRadioGroupChange(
                "TypeRegistration",
                state.PersonalAddressDataForm,
                e.target.value
              );
            }}
            items={TipoCadastroMedicoAssistenteOptions}
            error={state.PersonalAddressDataForm.TypeRegistration.Error}
          />
        </Grid>

        {state.PersonalAddressDataForm.TypeRegistration.Value ===
        "MedicoAssistenteEquipeCliECirur" ? (
          <Grid item xs={6} sm={6}>
            <Controls.Input
              name="MedicoTitularEquipe"
              label="Medico Titular da Equipe *"
              maxLength={100}
              placeholder={"Indicar o Médico Titular da Equipe"}
              value={state.PersonalAddressDataForm.MedicoTitularEquipe.Value}
              onChange={(e) => {
                onInputPersonalChange(
                  "MedicoTitularEquipe",
                  state.PersonalAddressDataForm,
                  e.target.value
                );
                onInputPersonalChange(
                  "MedicoTitularRetaguarda",
                  state.PersonalAddressDataForm,
                  ""
                );
              }}
              onBlur={(e) => {
                onInputPersonalChange(
                  "MedicoTitularEquipe",
                  state.PersonalAddressDataForm,
                  e.target.value
                );
              }}
              error={state.PersonalAddressDataForm.MedicoTitularEquipe.Error}
            />
          </Grid>
        ) : (
          <></>
        )}
        {state.PersonalAddressDataForm.TypeRegistration.Value ===
        "MedicoAssistenteEquipeRetaguarda" ? (
          <Grid item xs={6} sm={6}>
            <Controls.Input
              name="MedicoTitularRetaguarda"
              label="Medico Titular da Retaguarda *"
              maxLength={100}
              placeholder={"Indicar o Médico Titular da Retaguarda"}
              value={
                state.PersonalAddressDataForm.MedicoTitularRetaguarda.Value
              }
              onChange={(e) => {
                onInputPersonalChange(
                  "MedicoTitularRetaguarda",
                  state.PersonalAddressDataForm,
                  e.target.value
                );
                onInputPersonalChange(
                  "MedicoTitularEquipe",
                  state.PersonalAddressDataForm,
                  ""
                );
              }}
              onBlur={(e) => {
                onInputPersonalChange(
                  "MedicoTitularRetaguarda",
                  state.PersonalAddressDataForm,
                  e.target.value
                );
              }}
              error={
                state.PersonalAddressDataForm.MedicoTitularRetaguarda.Error
              }
            />
          </Grid>
        ) : (
          <></>
        )}
      </Grid>

      <Box mt={2}>
        <PersonalDataComponent
          PersonalDataForm={state.PersonalDataForm}
          onInputChange={onInputPersonalChange}
        />
      </Box>

      <Steps.StepTitle text="Endereço Residencial" />

      <Box mt={4}>
        <AddressDataComponent
          AddressDataForm={state.AddressDataForm}
          onInputChange={onInputAddressChange}
        />
      </Box>
    </div>
  );
}
